class ProductDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  connectedCallback() {
    // Hide drawer immediately to prevent flicker
    this.style.visibility = 'hidden';
    
    // Move drawer to body if not already there (similar to modal-dialog)
    if (this.moved) return;
    this.moved = true;
    
    // Use requestAnimationFrame to ensure DOM is ready before moving
    requestAnimationFrame(() => {
      document.body.appendChild(this);
      
      // Set up overlay click listener
      const overlay = this.querySelector('.product-drawer__overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      
      // Set up click listener on drawer container to close when clicking outside inner content
      this.addEventListener('click', (event) => {
        // Only close if clicking on the drawer container itself or the overlay, not on inner content
        if (event.target === this || event.target === overlay) {
          this.close();
        }
      });
      
      // Prevent clicks inside inner drawer from closing it
      const inner = this.querySelector('.product-drawer__inner');
      if (inner) {
        inner.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      }
      
      // Set up close button listeners
      const closeButtons = this.querySelectorAll('.product-drawer__close');
      closeButtons.forEach(button => {
        button.addEventListener('click', this.close.bind(this));
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    // Remove inline visibility style to allow CSS to control it
    this.style.visibility = '';
    
    // Add active class with slight delay to ensure animation triggers
    setTimeout(() => {
      this.classList.add('animate', 'active');
    }, 10);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('.product-drawer__inner');
        const focusElement = this.querySelector('.product-drawer__close') || this.querySelector('.product-drawer__inner');
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    
    // Restore focus to the element that opened the drawer
    if (this.activeElement) {
      this.activeElement.focus();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('product-drawer', ProductDrawer);

// Product Drawer Opener - handles opening product drawers
class ProductDrawerOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (!button) return;
    
    button.addEventListener('click', () => {
      const drawerId = this.getAttribute('data-drawer');
      if (drawerId) {
        const drawer = document.querySelector(drawerId);
        if (drawer && drawer.tagName === 'PRODUCT-DRAWER') {
          drawer.open(button);
        }
      }
    });
  }
}

customElements.define('product-drawer-opener', ProductDrawerOpener);

